import { getMomentTz } from "@dexteel/mesf-core";

import { MechanicalTestRunDisposition } from "../../models/MechanicalTestRunDisposition";

const moment = getMomentTz();

// Failed values render red/bold in the cell; the violated limit goes in a
// tooltip (a "(Min: X)" suffix wrapped badly in the narrow panel).
export const formatMechanicalValue = (
	value: number | null,
	_passed: boolean | null,
	_min: number | null,
	_max: number | null,
	decimals?: number,
	_minCompare: number | null = _min,
	_maxCompare: number | null = _max,
) => {
	if (value == null) return "-";
	return decimals != null ? value.toFixed(decimals) : value;
};

export const mechanicalFailDetail = (
	value: number | null,
	min: number | null,
	max: number | null,
	minCompare: number | null = min,
	maxCompare: number | null = max,
): string | null => {
	if (value == null) return null;
	if (minCompare != null && value < minCompare) return `Min: ${min}`;
	if (maxCompare != null && value > maxCompare) return `Max: ${max}`;
	return null;
};

const trimNumber = (value: number) => String(Number(value.toFixed(3)));

export const formatRange = (
	min: number | null | undefined,
	max: number | null | undefined,
	unit?: string | null,
) => {
	const suffix = unit ? ` ${unit}` : "";
	if (min != null && max != null)
		return `${trimNumber(min)} – ${trimNumber(max)}${suffix}`;
	if (min != null) return `≥ ${trimNumber(min)}${suffix}`;
	if (max != null) return `≤ ${trimNumber(max)}${suffix}`;
	return "-";
};

export const formatTimestamp = (timestamp: Date | null | undefined) =>
	timestamp ? moment(timestamp).format("MM/DD HH:mm") : "-";

export const formatDate = (timestamp: Date) =>
	moment(timestamp).format("MM/DD");

export const formatTime = (timestamp: Date) =>
	moment(timestamp).format("HH:mm");

export const disposedByLabel = (
	disposition: MechanicalTestRunDisposition | null,
) => {
	if (!disposition) return "-";
	return disposition.DisposedBy?.trim().toLowerCase() === "auto"
		? "Auto"
		: disposition.DisposedBy;
};
